
import React, { useState, useEffect, useRef } from 'react';
import { ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER, ORG_GET_CONFIGURATION_CONTACTS_LIST, ORG_CONFIGURATION_TEMPLETE_LIST, ORG_CONFIGURATION_SEND_REMINDER } from '../../../../ApiServices/BaseURL';
import { postData, getData } from '../../../../ApiServices/ApiService';
import { useTheme } from '../../../../GlobalContext/GlobalContext';
import { logFrontendException } from '../../../../Utils/Exception'

const ReminderRegisterController = () => {
  const { setIsLoginPopup } = useTheme();
  const pageName = "ReminderRegisterController";
  const [selectList, setSelectList] = useState('');
  const [selectClient, setSelectClient] = useState('');
  const [channel, setChannel] = useState('');
  const [template, setTemplate] = useState('');
  const [selectTemplate, setSelectTemplate] = useState('');
  const [messageContent, setMessageContent] = useState('');
  const [scheduleFor, setScheduleFor] = useState('');
  const [date, setDate] = useState('');
  const [recipientSource, setRecipientSource] = useState("list");
  const [loading, setLoading] = useState(false);
  const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [isPreview, setIsPreview] = useState(false);

  const handleOpenDeleteModal = () => {
    setIsDeleteModalOpen(true); // Open the modal
  };

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false); // Close the modal
    setSelectedDocument(null);
  };

    const [userPermissions, setUserPermissions] = useState(null);
    useEffect(() => {
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      setUserPermissions(storedUserInfo?.user_permissions || {});
    }, [])
  

  // const clientsList = [
  //     { clientName: "Client Name" },
  //     { clientName: "Client Name" },
  //     { clientName: "Client Name" },
  //     { clientName: "Client Name" },
  //     { clientName: "Client Name" },
  //     { clientName: "Client Name" },
  //   ];
  const storedUserWhataApp = JSON.parse(localStorage.getItem('whatsAppStatus'));
  const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
  const channelOptions = [
    storedUserWhataApp === 1 && storedUserInfo?.user_permissions?.config?.per_name_sub_json?.reminder_reg_whatsapp === 1 ? { label: "WhatsApp", value: 'whatsapp' } : null,
    storedUserInfo?.user_permissions?.config?.per_name_sub_json?.reminder_reg_email === 1 && { label: "Email", value: 'email' },
    storedUserInfo?.user_permissions?.config?.per_name_sub_json?.reminder_reg_sms === 1 && { label: "SMS", value: 'sms' }
  ].filter(Boolean);


  useEffect(() => {
    fetchContactList();
  }, []);

  const getLocalDateTime = () => {
    const now = new Date();
    const tzOffset = now.getTimezoneOffset() * 60000; // offset in milliseconds
    return new Date(now - tzOffset).toISOString().slice(0, 16); // "YYYY-MM-DDTHH:MM"
  };

  useEffect(() => {
    if (scheduleFor === "Now") {
      setDate(getLocalDateTime());
    }
  }, [scheduleFor]);


  const [clientList, setClientList] = useState([]);
  const [error, setError] = useState('');
  const [searchUser, setSearchUser] = useState('');
  const [selectedClientError, setSelectedClientError] = useState('');
  const [selectedClients, setSelectedClients] = useState([]);

  const handleSearchClient = async () => {
    try {
      setError('');
      setSelectedClientError('');
      setLoading(true);
      setClientList([]);
      setAddClientError('')
      // setSelectedClients([])
      if (!searchUser) {
        setError('Please enter valid text'); return;
      }
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payLoad = { emp_id_auth: storedUserInfo?.emp_id, search_type: "GENERIC", search_word: searchUser }

      //console.log('team Data', payLoad);
      // Make the API call
      const response = await postData(ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER, payLoad);
      const responseData = await response.json();
      //console.log('response Data', responseData);

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            setClientList(responseData?.dataJ || []);
            // setSuccess(responseData?.info);
            setTimeout(() => {
              // handleClose();
              // onValueChange();
            }, 3000);
          } else {
            setError(responseData?.info || 'Failed to fetch Client. Please try again.');
            logFrontendException(storedUserId, pageName, "handleSearchClient", responseData || '');
          }
        } else {
          setError(responseData?.info || 'Failed to fetch Client.');
          logFrontendException(storedUserId, pageName, "handleSearchClient", responseData || '');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        setError('Unauthorized access. Your session may have expired. Please log in again.');
        logFrontendException(storedUserId, pageName, "handleSearchClient", responseData || response || '');
        // Optionally, redirect to the login page or refresh the token
        // Example: redirectToLogin();

        setIsLoginPopup(true)
      }
      // Unexpected or network-related errors
      else {
        setError('Unexpected error occurred. Please try again later.');
        logFrontendException(storedUserId, pageName, "handleSearchClient", responseData || response || '');
      }
    } catch (error) {
      logFrontendException(storedUserId, pageName, "handleSearchClient-catch", error || '');
      // Handle various error scenarios
      if (error.response) {
        // Server responded with a status outside the 2xx range
        setError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch Client. Please try again.'}`);
      } else if (error.request) {
        // Request was made but no response was received
        setError('No response received from the server. Please check your network connection and try again.');
      } else {
        // An error occurred in setting up the request
        setError(`Something went wrong while processing your request. Please check your network connection and try again.`);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSearchInputText = (value) => {
    setSearchUser(value);
    // setClientNameError('');
    setClientList([]);
    if (!value) {
      setSearchUser('');
    }
  };

  const [selectedClient, setSelectedClient] = useState(null);
  const handleSelectClient = (client) => {
    setSelectedClient(client);
    setSelectedClients(client)
    setSearchUser(client?.client_name);
    setClientList([]);
    setSelectedClientError('');
  };

  const [clientsList, setClientsList] = useState([]);
  const [addClientError, setAddClientError] = useState('');
  const handleAddClient = () => {
    setError('');
    if (!searchUser || !selectedClient?.client_id) {
      setAddClientError('No client selected.');
      setSelectedClients(null);
      return;
    }
    if (selectedClients && selectedClients.client_id) {
      const alreadyExists = clientsList.some(
        (c) => c.client_id === selectedClients.client_id
      );

      if (alreadyExists) {
        setAddClientError('Client already added to the list.');
      } else {
        setClientsList([...clientsList, selectedClients]);
        setSelectedClients(null);
        setSearchUser('');
        setAddClientError('');
        setError('');
      }
    }
  };


  const [contactListLoading, setContactListLoading] = useState(false);
  const [contactListError, setContactListError] = useState('');
  const [contactListList, setContactListList] = useState([]);
  const fetchContactList = async () => {
    setContactListList([])
    setContactListLoading(true);
    setContactListError('');
    try {
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payload = {
        "action_type": "list_of_contact_lists",
        "emp_id_auth": storedUserInfo?.emp_id,
      }
      const response = await postData(ORG_GET_CONFIGURATION_CONTACTS_LIST, payload);
      const responseData = await response.json();


      if (response.status === 200 && responseData.status_code === 200) {
        if (responseData.message.toLowerCase() === "success") {
          if (responseData?.dataJ?.length > 0) {
            // setContactListList(responseData?.dataJ || []);
            const filterData = responseData?.dataJ.map(contact => ({
              label: contact?.list_name,
              value: contact?.list_id
            }));
            setContactListList(filterData || []);
            // setCurrentPage(1);
          } else {
            setContactListError(responseData?.info || "Failed to fetch contact list.");
            // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
            logFrontendException(storedUserId, pageName, "fetchContactList", responseData || '');

          }
        } else {
          setContactListError(responseData?.info || "Failed to fetch contact list.");
          // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
          logFrontendException(storedUserId, pageName, "fetchContactList", responseData || '');
        }
      } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        setContactListError('Unauthorized access. Your session may have expired. Please log in again.');
        setIsLoginPopup(true)
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "fetchContactList", responseData || response || '');

      } else {
        setContactListError(responseData?.info || "Failed to fetch  contact list.");
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "fetchContactList", responseData || response || '');
      }
    } catch (err) {
      setContactListError("Network error. Please try again.");
      logFrontendException(storedUserId, pageName, "fetchContactList-catch", err || '');
    } finally {
      setContactListLoading(false);
    }
  };

  const [contactLoading, setContacttLoading] = useState(false);
  const [contactError, setContacttError] = useState('');
  const [contacttList, setContactList] = useState([]);
  const [groupedContacts, setGroupedContacts] = useState({
    whatsapp: [],
    email: [],
    sms: []
  });
  const fetchContact = async (listId) => {
    setContactList([])
    setContacttLoading(true);
    setContacttError('');
    try {
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payload = {
        "action_type": "contacts_of_list",
        "emp_id_auth": storedUserInfo?.emp_id,
        "list_id": listId,
      }
      const response = await postData(ORG_GET_CONFIGURATION_CONTACTS_LIST, payload);
      const responseData = await response.json();


      if (response.status === 200 && responseData.status_code === 200) {
        if (responseData.message.toLowerCase() === "success") {
          if (responseData?.dataJ?.length > 0) {
            const fullList = [...(responseData?.dataJ[0]?.whatsapp || []), ...(responseData?.dataJ[0]?.email || []), ...(responseData?.dataJ[0]?.sms || [])];
            console.log("responseData?.dataJ?.whatsapp", fullList)
            // Set full contact list for displaying
            setContactList(fullList);

            // Set grouped contacts for payload usage
            setGroupedContacts({
              whatsapp: responseData?.dataJ[0]?.whatsapp || [],
              sms: responseData?.dataJ[0]?.sms || [],
              email: responseData?.dataJ[0]?.email || [],
            });

            // const filterData = responseData?.dataJ.map(contact => ({
            //     label: contact?.list_name,
            //     value: contact?.list_id
            //   }));
            //   setContactListList(filterData || []);
            // setCurrentPage(1);
          } else {
            setContacttError(responseData?.info || "Failed to fetch contacts.");
            // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
            logFrontendException(storedUserId, pageName, "fetchContact", responseData || '');

          }
        } else {
          setContacttError(responseData?.info || "Failed to fetch contacts.");
          // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
          logFrontendException(storedUserId, pageName, "fetchContact", responseData || '');
        }
      } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        setContacttError('Unauthorized access. Your session may have expired. Please log in again.');
        setIsLoginPopup(true)
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "fetchContact", responseData || response || '');

      } else {
        setContacttError(responseData?.info || "Failed to fetch  contacts.");
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "fetchContact", responseData || response || '');
      }
    } catch (err) {
      setContacttError("Network error. Please try again.");
      logFrontendException(storedUserId, pageName, "fetchContact-catch", err || '');
    } finally {
      setContacttLoading(false);
    }
  };

  const [templateLoading, setTemplateLoading] = useState(false);
  const [templateError, setTemplateError] = useState('');
  const [templateList, setTemplateList] = useState([]);
  const fetchTemplates = async (channelType) => {
    setTemplateList([])
    setTemplateLoading(true);
    setTemplateError('');
    try {
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payload = {
        "emp_id_auth": storedUserInfo?.emp_id,
        "channel_name": channelType.label,
      }
      const response = await postData(ORG_CONFIGURATION_TEMPLETE_LIST, payload);
      const responseData = await response.json();


      if (response.status === 200 && responseData.status_code === 200) {
        if (responseData.message.toLowerCase() === "success") {
          if (responseData?.dataJ?.length > 0) {
            // setTemplateList(responseData?.dataJ || []);
            const filterData = responseData?.dataJ.map(template => ({
              label: template?.template_name,
              value: template?.template_name,
              template_text: template?.template_text,
              template_id: template?.template_id,
              serial_id: template?.serial_id
            }));
            setTemplateList(filterData || []);
            // setCurrentPage(1);
          } else {
            setTemplateError(responseData?.info || "Failed to fetch contacts.");
            // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
            logFrontendException(storedUserId, pageName, "fetchContact", responseData || '');

          }
        } else {
          setTemplateError(responseData?.info || "Failed to fetch contacts.");
          // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
          logFrontendException(storedUserId, pageName, "fetchContact", responseData || '');
        }
      } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        setTemplateError('Unauthorized access. Your session may have expired. Please log in again.');
        setIsLoginPopup(true)
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "fetchContact", responseData || response || '');

      } else {
        setTemplateError(responseData?.info || "Failed to fetch  contacts.");
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "fetchContact", responseData || response || '');
      }
    } catch (err) {
      setTemplateError("Network error. Please try again.");
      logFrontendException(storedUserId, pageName, "fetchContact-catch", err || '');
    } finally {
      setTemplateLoading(false);
    }
  };

  const [currentContactPage, setCurrentContactPage] = useState(1);
  const [currentClientPage, setCurrentClientPage] = useState(1);
  const itemsPerPage = 5;

  const totalPages = Math.ceil(contacttList?.length / itemsPerPage);
  const indexOfLastItem = currentContactPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentContacts = contacttList?.slice(indexOfFirstItem, indexOfLastItem);

  const totalClientPages = Math.ceil(clientsList?.length / itemsPerPage);
  const indexOfClientLastItem = currentClientPage * itemsPerPage;
  const indexOfClientFirstItem = indexOfClientLastItem - itemsPerPage;
  const currentClient = clientsList?.slice(indexOfClientFirstItem, indexOfClientLastItem);

  const handleContactPageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentContactPage(pageNumber);
    }
  };

  const handleClientPageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalClientPages) {
      setCurrentClientPage(pageNumber);
    }
  };


  const [submitReminderLoading, setSubmitReminderLoading] = useState(false);
  const [submitReminderError, setSubmitReminderError] = useState('');
  const [submitReminderSuccess, setSubmitReminderSuccess] = useState('');
  const [channelSelectError, setChannelSelectError] = useState('');
  const [scheduleForError, setScheduleForError] = useState('');

  const handleCancel = () => {
    setRecipientSource("list");
    setSelectList("");
    setSelectClient(null);
    setChannel("");
    setTemplate("");
    setMessageContent("");
    setScheduleFor("");
    setDate("");
    setSearchUser("");
    setClientsList([]);
    setContactList([]);
    setCurrentClientPage(1);
    setCurrentContactPage(1);
    setContactListError("");
    setChannelSelectError("");
    setTemplateError("");
    setError("");
    setAddClientError("");
    setSelectedDocument(null);
    setSelectTemplate(null);
    setScheduleForError('');
    setContacttError('');
    setTemplateList([]);
  };


  const handleSubmitReminder = async (channelType) => {
    setSubmitReminderSuccess('');
    setSubmitReminderError('');
    setChannelSelectError('');
    setContactListError('');
    setTemplateError('');
    setError('');
    setScheduleForError('');
    setAddClientError('');
    setContacttError('')
    const hasClients = clientsList && clientsList.length > 0;
    const hasContacts = contacttList && contacttList.length > 0;

    if (recipientSource === 'client' && !hasClients) {
      setError("Please add a client to proceed");
      return;
    }
    if (recipientSource === 'list') {
      // ✅ Validation 4: Selected list is empty
      if (!selectList || !selectList.value) {
        setContactListError("Please select a contact list to proceed.");
        return;
      }

      if (!hasContacts) {
        setContactListError("Selected list has no contacts. Please choose a valid list with contacts.");
        return;
      }
    }
    if (!channel || !channel.label) {
      setChannelSelectError("Please select at least one communication channel (WhatsApp, SMS, Email) to send the reminder.");
      return;
    }
    if (!template || !template.label || !template.template_text) {
      setTemplateError("Please select a message template before proceeding.");
      return;
    }
    if (!scheduleFor) {
      setScheduleForError("Please select schedule type");
      return;
    }
    setSubmitReminderLoading(true);
    try {
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

      const payload = {
        "action_type": 'insert_reminder_record',
        emp_id_auth: storedUserInfo?.emp_id,
        channel_name: channel?.label,
        template_name: template?.label,
        template_text: template?.template_text,
        template_id: template?.template_id,
        t_serial_id: template?.serial_id,
        schedule_type: scheduleFor,
        schedule_time: date,
        recipient_type: recipientSource, // 'list' or 'client'
        recipient_value: recipientSource === 'list' ? selectList?.value : null,
        // contacts: recipientSource === 'list'
        //   ? contacttList.map(c => ({
        //     contact_name: c?.contact_name,
        //   }))
        //   : clientsList.map(c => ({
        //     client_name: c?.client_name,
        //     contact_name: c?.contact_name,
        //     client_id: c?.client_id
        //   }))
        contacts:
          recipientSource === 'client'
            ? clientsList.map(c => ({
              client_name: c?.client_name,
              contact_name: c?.contact_name,
              client_id: c?.client_id,
              contact_email: c?.contact_email,
              contact_phone_no: c?.contact_phone_no,
            }))
            : channel?.label?.toLowerCase() === 'whatsapp'
              ? groupedContacts.whatsapp || []
              : channel?.label?.toLowerCase() === 'email'
                ? groupedContacts.email || []
                : channel?.label?.toLowerCase() === 'sms'
                  ? groupedContacts.sms || []
                  : []
      };

      console.log("Final Reminder Payload:", payload);

      const response = await postData(ORG_CONFIGURATION_SEND_REMINDER, payload);
      const responseData = await response.json();


      if (response.status === 200 && responseData.status_code === 200) {
        if (responseData.message.toLowerCase() === "success") {
          setSubmitReminderSuccess(responseData?.info);
          handleCancel();
          setTimeout(() => {
            setSubmitReminderSuccess();
          }, 3000);
        } else {
          setSubmitReminderError(responseData?.info || "Failed to submit reminder.");
          // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
          logFrontendException(storedUserId, pageName, "handleSubmitReminder", responseData || '');
        }
      } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        setSubmitReminderError('Unauthorized access. Your session may have expired. Please log in again.');
        setIsLoginPopup(true)
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "handleSubmitReminder", responseData || response || '');

      } else {
        setSubmitReminderError(responseData?.info || "Failed to submit reminder.");
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "handleSubmitReminder", responseData || response || '');
      }
    } catch (err) {
      setSubmitReminderError("Network error. Please try again.");
      logFrontendException(storedUserId, pageName, "handleSubmitReminder-catch", err || '');
    } finally {
      setSubmitReminderLoading(false);
    }
  };

  const preview = `Dear USER, 

We are from Free Tax Filer. 😊 

Thank you for using our Tax Estimation service. 

As discussed, please find the payment link below to proceed with your Tax Return. 

{{product_details}} After making the payment, kindly send a screenshot to this WhatsApp number for reference. 📸 Additionally, we need the following details for your Tax Filing. Please share them at your earliest convenience: 

🏦 Bank Account Details:  
Bank account number:  
IFSC Code: 💻 

Income Tax Portal (IT Portal) Login Details:  
Username (PAN):  
Password: 📌 

Note: If this is your first time filing taxes, please also share your Aadhaar number, PAN card, registered Aadhaar mobile number, and email ID. 

Best Regards,  
Free Tax Filer  
Ph: 9154820689  
✉ Email: info@freetaxfiler.com  
🌐 https://freetaxfiler.com  

Custom Field {{name}}`;

  const handleShowPreview = () => {
    setIsPreview(!isPreview);
  }

  return {
    clientsList,
    selectList,
    setSelectList,
    selectClient,
    setSelectClient,
    channel,
    setChannel,
    selectTemplate,
    setSelectTemplate,
    messageContent,
    setMessageContent,
    scheduleFor,
    setScheduleFor,
    date,
    setDate,
    channelOptions,
    recipientSource,
    setRecipientSource,
    loading,
    handleSearchClient,
    setSearchUser,
    searchUser,
    clientList,
    error,
    handleSearchInputText,
    handleSelectClient,
    selectedClients,
    handleAddClient,
    preview,
    setClientsList,
    setError,
    contactListList,
    contactListError,
    contactListLoading,
    contacttList,
    contactError,
    contactLoading,
    fetchContact,
    setContacttError,
    setContactList,
    currentContacts,
    totalPages,
    totalClientPages,
    currentClientPage,
    currentContactPage,
    handleClientPageChange,
    handleContactPageChange,
    currentClient,
    setCurrentClientPage,
    setCurrentContactPage,
    fetchTemplates,
    templateList,
    templateError,
    templateLoading,
    setTemplate,
    template,
    handleOpenDeleteModal,
    handleCloseDeleteModal,
    isDeleteModalOpen,
    setIsDeleteModalOpen,
    selectedDocument,
    setSelectedDocument,
    addClientError,
    handleSubmitReminder,
    submitReminderSuccess,
    submitReminderError,
    submitReminderLoading,
    channelSelectError,
    setContactListError,
    setChannelSelectError,
    setTemplateError,
    handleCancel,
    groupedContacts,
    setGroupedContacts,
    scheduleForError,
    setScheduleForError,isPreview,setIsPreview,
    setAddClientError, handleShowPreview
  }

}

export default ReminderRegisterController